// React
import React from "react";

// Utility functions, hooks, actions, and translations
import { useTranslation } from "react-i18next";
import { APPLICATION_CARD_ACTIONS, SUBSTATUS_APPLICATION_CARD_ACTIONS } from "../../../components/ApplicationList/actions";
import useApplicationActions from "../../../hooks/useApplicationActions";
import Dropdown from "react-dropdown";

// Components
import { StatusSelectorWrapper, StatusSelectorPlaceholder } from "./StatusSelector.styled";

const StatusSelector = ({ application, loading, hideOnMobile, handleChange, manageShareholder }) => {
  const { t } = useTranslation();
  const isLoadingState = loading || !application;
  const { loading: applicationActionLoading, handleActionTaken } = useApplicationActions("set_substatus", () => {}, application ? [application] : [], {}, true);

  // Return null if the user is a shareholder, as they should not see the status selector
  if (manageShareholder) {
    return null;
  }

  const handleStatusUpdate = async (selectedOption) => {
    const substatus = selectedOption?.value || "";

    // Use handleActionTaken to update the substatus
    await handleActionTaken({ substatus });

    // Update the application status in the parent component
    handleChange(application, selectedOption);
  };

  const dropdownOptions = [
    {
      value: "applied",
      label: t("component.application_status_list.submitted", "Submitted"),
    },
    ...APPLICATION_CARD_ACTIONS.filter((action) => SUBSTATUS_APPLICATION_CARD_ACTIONS.includes(action.name)).map((action) => ({
      value: action.name,
      label: t(action.i18nKey[0], action.i18nKey[1]),
    })),
  ];

  return (
    <StatusSelectorWrapper>
      {isLoadingState ? (
        <StatusSelectorPlaceholder aria-hidden="true" />
      ) : (
        <Dropdown
          options={dropdownOptions}
          placeholder={t("common.statusSelect")}
          name="substatus"
          value={dropdownOptions.find((option) => option.value === application?.substatus)}
          onChange={handleStatusUpdate}
          menuClassName="application-status-selector-dropdown"
          disabled={!(["submitted", "invited"].includes(application?.status)) || applicationActionLoading || manageShareholder}
          hideLabel
          hideOnMobile={hideOnMobile}
        />
      )}
    </StatusSelectorWrapper>
  );
};

export default StatusSelector;
